export default "__VITE_PUBLIC_ASSET__4bf5e63e__"